import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/background_image.png'


const _hoisted_1 = { class: "h-screen bg-access_point-300 flex flex-col container" }
const _hoisted_2 = { class: "flex items-center w-full flex-col bg-white absolute bottom-0 login" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLogin = _resolveComponent("HeaderLogin")!
  const _component_LoginForm = _resolveComponent("LoginForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderLogin, {
      title: "ACCESS POINT",
      "sub-title": "seguro e fácil"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoginForm, { class: "z-10" })
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("img", {
      src: _imports_0,
      class: "img z-1 w-full"
    }, null, -1))
  ]))
}